const config = {
  contentful: {
    accessToken: 'oKnPnLrgUVk8H5JkQYwXnmRDqoHO33--BzmTxPpRcfw',
    space: '9y4fi2gkk4ov',
    environment: 'master',
  },
  nacelle: {
    accessToken: '45bc6f8e-5b42-4cbd-8507-0d6046b75315',
    endpoint:
      'https://storefront.api.nacelle.com/graphql/v1/spaces/439bb8c3-09f9-4814-8164-b13837e95f4f',
  },
  ninetailed: {
    previewPlugin: {
      clientId: '79e33a8f-9ff5-4ef2-963f-9865902d9904',
      secret: '5e0906fa-08d5-4271-9848-e3e4bfa08086',
    },
    provider: {
      clientId: '959454bc-e4e6-4088-9861-937af542b86e',
      environment: 'main',
    },
  },
  searchspring: {
    siteId: 'rguexy',
  },
  trustpilot: {
    url: 'https://uk.trustpilot.com/review/ruggable.co.uk',
    businessId: '609c1455ad338c00019afcb8',
  },
  defaultLocale: 'en-GB',
};

export default config;
